import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", null, " Zusammensetzung der Stromlieferung ", -1)
const _hoisted_2 = {
  key: 0,
  class: "io-electricity-labelings"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  class: "io-electricity-labelings__content row",
  ref: "contentRow"
}
const _hoisted_5 = { ref: "chartCont" }
const _hoisted_6 = { class: "values" }
const _hoisted_7 = { class: "font-regular" }
const _hoisted_8 = { class: "font-regular" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "font-regular" }
const _hoisted_11 = { class: "font-regular" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "font-regular" }
const _hoisted_14 = { class: "font-regular" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "font-regular" }
const _hoisted_17 = { class: "font-regular" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "font-regular" }
const _hoisted_20 = { class: "font-regular" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "font-regular" }
const _hoisted_23 = { class: "font-regular" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "font-regular" }, [
  /*#__PURE__*/_createTextVNode(" CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode("-Emissionen ")
], -1)
const _hoisted_27 = { class: "font-regular" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "font-regular" }, " Radioaktiver Abfall ", -1)
const _hoisted_29 = { class: "font-regular" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IoHeadline = _resolveComponent("IoHeadline")!
  const _component_IoSpacer = _resolveComponent("IoSpacer")!
  const _component_IoText = _resolveComponent("IoText")!
  const _component_GridCol = _resolveComponent("GridCol")!
  const _component_VueApexCharts = _resolveComponent("VueApexCharts")!
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_GridRow = _resolveComponent("GridRow")!

  return (_openBlock(), _createBlock(_component_GridRow, { g: "5" }, {
    default: _withCtx(() => [
      _createVNode(_component_GridCol, { s: { xs: 12, lg: 6, xl: 5, xxl: 4 } }, {
        default: _withCtx(() => [
          _createVNode(_component_IoHeadline, {
            size: "h2",
            align: "start",
            "text-align": "start"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_IoSpacer, { size: "medium" }),
          _createVNode(_component_IoText, { "text-align": "start" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _createVNode(_component_GridCol, { s: { xs: 12, lg: 6, xl: 7, xxl: 8 } }, {
        default: _withCtx(() => [
          (_ctx.activeElectricityLabeling)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass(["io-electricity-labelings__navigation font-regular", { 'scroll-shadow': _ctx.showScrollShadow }])
                }, [
                  _createElementVNode("div", {
                    class: "scroll-container",
                    ref: "scrollContainer",
                    onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollBarShadowHandler && _ctx.scrollBarShadowHandler(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.electricityLabelings, (electricityLabeling, inx) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: `elb-${inx}`,
                        onClick: ($event: any) => (_ctx.changeElectricityLabeling($event, inx)),
                        class: _normalizeClass({ 'active': _ctx.activeElectricityLabelingKey === inx })
                      }, _toDisplayString(electricityLabeling.title), 11, _hoisted_3))
                    }), 128))
                  ], 544)
                ], 2),
                _createVNode(_component_IoSpacer, { size: "medium" }),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["io-electricity-labelings__content__chart", _ctx.isMobile ? 'col-12' : 'col'])
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_VueApexCharts, {
                        series: _ctx.chartValues,
                        options: _ctx.chartOptions,
                        type: "donut"
                      }, null, 8, ["series", "options"])
                    ], 512)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["io-electricity-labelings__content__legend", _ctx.isMobile ? 'col-12' : 'col'])
                  }, [
                    (_ctx.isMobile)
                      ? (_openBlock(), _createBlock(_component_IoSpacer, {
                          key: 0,
                          size: "medium"
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("table", _hoisted_6, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_7, [
                          _createVNode(_component_FaIcon, {
                            icon: "fas fa-circle",
                            style: _normalizeStyle(`color: ${_ctx.chartOptions.colors[0]}`)
                          }, null, 8, ["style"])
                        ]),
                        _createElementVNode("td", _hoisted_8, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(_ctx.chartValues[0], 1, true)) + " %", 1)
                        ]),
                        _createElementVNode("td", {
                          class: "font-regular",
                          innerHTML: _ctx.labels[0]
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_10, [
                          _createVNode(_component_FaIcon, {
                            icon: "fas fa-circle",
                            style: _normalizeStyle(`color: ${_ctx.chartOptions.colors[1]}`)
                          }, null, 8, ["style"])
                        ]),
                        _createElementVNode("td", _hoisted_11, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(_ctx.chartValues[1], 1, true)) + " %", 1)
                        ]),
                        _createElementVNode("td", {
                          class: "font-regular",
                          innerHTML: _ctx.labels[1]
                        }, null, 8, _hoisted_12)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_13, [
                          _createVNode(_component_FaIcon, {
                            icon: "fas fa-circle",
                            style: _normalizeStyle(`color: ${_ctx.chartOptions.colors[2]}`)
                          }, null, 8, ["style"])
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(_ctx.chartValues[2], 1, true)) + " %", 1)
                        ]),
                        _createElementVNode("td", {
                          class: "font-regular",
                          innerHTML: _ctx.labels[2]
                        }, null, 8, _hoisted_15)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_16, [
                          _createVNode(_component_FaIcon, {
                            icon: "fas fa-circle",
                            style: _normalizeStyle(`color: ${_ctx.chartOptions.colors[3]}`)
                          }, null, 8, ["style"])
                        ]),
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(_ctx.chartValues[3], 1, true)) + " %", 1)
                        ]),
                        _createElementVNode("td", {
                          class: "font-regular",
                          innerHTML: _ctx.labels[3]
                        }, null, 8, _hoisted_18)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_19, [
                          _createVNode(_component_FaIcon, {
                            icon: "fas fa-circle",
                            style: _normalizeStyle(`color: ${_ctx.chartOptions.colors[4]}`)
                          }, null, 8, ["style"])
                        ]),
                        _createElementVNode("td", _hoisted_20, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(_ctx.chartValues[4], 1, true)) + " %", 1)
                        ]),
                        _createElementVNode("td", {
                          class: "font-regular",
                          innerHTML: _ctx.labels[4]
                        }, null, 8, _hoisted_21)
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_22, [
                          _createVNode(_component_FaIcon, {
                            icon: "fas fa-circle",
                            style: _normalizeStyle(`color: ${_ctx.chartOptions.colors[5]}`)
                          }, null, 8, ["style"])
                        ]),
                        _createElementVNode("td", _hoisted_23, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(_ctx.chartValues[5], 1, true)) + " %", 1)
                        ]),
                        _createElementVNode("td", {
                          class: "font-regular",
                          innerHTML: _ctx.labels[5]
                        }, null, 8, _hoisted_24)
                      ])
                    ]),
                    _createVNode(_component_IoSpacer, { size: "medium" }),
                    _hoisted_25,
                    _createVNode(_component_IoSpacer, { size: "medium" }),
                    _createElementVNode("table", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_26,
                        _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.formatNumber(_ctx.activeElectricityLabeling.values.co2, 4, true)) + " g/kWh ", 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_28,
                        _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.formatNumber(_ctx.activeElectricityLabeling.values.radioactiveWaste, 4, true)) + " g/kWh ", 1)
                      ])
                    ])
                  ], 2)
                ], 512)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}